export default (errorData, isCP) => {
  return isCP ?
    {
      event: 'errorCP',
      actionable: errorData.actionable, // action that can be taken
      code: errorData.code, // Error code
      storefront: errorData.storefront,
      errorMsg: errorData.message,
      typeofPayment: errorData.typeofPayment,
      pnr: errorData.pnr,
      numPax: errorData.numPax,
      CPmis: errorData.CPmis,
      URLpath: errorData.url,
    } : {
      event: 'error',
      type: errorData.type, // Error type
      statusCode: errorData.statusCode, // HTTP Status Code
      code: errorData.code, // Error code
      actionable: errorData.actionable, // action that can be taken
      actionType: errorData.actionType,
      errorMsg: errorData.message,
      errorExtraInfo: errorData.extraInfo, // dynamic data
      URLpath: errorData.url,
    };
};
